module.exports = __webpack_public_path__ + "media/components/footer/static/acredited-9b951484e163a4e490dc739c5bf03752.png";